import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';
import * as fs from 'file-saver';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';

@Injectable({
  providedIn: 'root'
})

export class ArquivoService extends AbstractIdbaService {
  constructor(http: HttpClient, public snackBar: CustomSnackBarService) {
    super(http);
    this.programName = 'cad/arquivo/arquivo.p';
  }

  download(idArquivo) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-download';
    request.parameters = { idArquivo };
    this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    }).subscribe({
      next: (response) => {
        const arquivos = response?.body?.retorno?.arquivos;
        if (arquivos && arquivos.length > 0) {
            if (arquivos[0].extensao.toLowerCase() === "xml" )
            {
              const blob = new Blob([arquivos[0].conteudo], { type: 'application/xml' });

              const url = URL.createObjectURL(blob);

              const a = document.createElement('a');
              a.href = url;
              a.download = arquivos[0].nome;
              a.click();

              URL.revokeObjectURL(url);
            }
            else if (arquivos[0].extensao.toLowerCase() === "json" )
            {
              const blob = new Blob([arquivos[0].conteudo], { type: 'application/json' });

              const url = URL.createObjectURL(blob);

              const a = document.createElement('a');
              a.href = url;
              a.download = arquivos[0].nome;
              a.click();

              URL.revokeObjectURL(url);
            }
            else
              fs.saveAs(this.base64toBlob(arquivos[0].conteudo), arquivos[0].nome);
        } else {
          this.snackBar.openSnackBar(`Arquivo não disponível para download.`, null, 'Warn');
        }
      },
      error: (err) => {
        this.snackBar.openSnackBar(`Falha ao realizar download do arquivo.`, null, 'Error');
      },
    });
  }

  downloadXml(idArquivo) {
    const request = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-download';
    request.parameters = { idArquivo };
    this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    }).subscribe({
      next: (response) => {
        const arquivos = response?.body?.retorno?.arquivos;
        if (arquivos && arquivos.length > 0) {
          const blob = new Blob([arquivos[0].conteudo], { type: 'application/xml' });

          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = arquivos[0].nome;
          a.click();

          URL.revokeObjectURL(url);
        } else {
          this.snackBar.openSnackBar(`Arquivo não disponível para download.`, null, 'Warn');
        }
      },
      error: (err) => {
        this.snackBar.openSnackBar(`Falha ao realizar download do arquivo.`, null, 'Error');
      },
    });
  }

  blobToBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1];
        resolve(base64String);
      };
      reader.onerror = error => reject(error);
    });
  }

  base64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
